import React from 'react';
import { Container } from 'semantic-ui-react';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

const getImageSrc = (item, scale = 'preview') => {
  if (!item?.['@id']) return null;
  // External URLs (allowExternals: true) are used as-is
  if (item['@type'] === 'URL') return item['@id'];
  return flattenToAppURL(item['@id']) + `/@@images/image/${scale}`;
};

const itemLinkView = (props) => {
  const { data } = props;
  const firstImage = data.image?.[0];
  const imageSrc = firstImage ? getImageSrc(firstImage) : null;
  const imageFallbackSrc =
    firstImage?.['@type'] !== 'URL' && firstImage?.['@id']
      ? flattenToAppURL(firstImage['@id']) + '/@@images/image'
      : null;
  let image = imageSrc && (
    <img
      src={imageSrc}
      alt={firstImage.Title}
      onError={(e) => {
        if (imageFallbackSrc && e.target.src !== imageFallbackSrc) {
          e.target.src = imageFallbackSrc;
        }
      }}
    />
  );
  return (
    <div className="block ch-item">
      <Container>
        <div className={data.typ || 'small'}>
          {data.link?.length > 0 ? (
            <UniversalLink href={data.link[0]['@id']} className="other-link">
              {image}
            </UniversalLink>
          ) : (
            image
          )}
          <div className="ch-item-text">{data.text}</div>
        </div>
      </Container>
    </div>
  );
};

export default itemLinkView;
